import { useEffect, useState } from 'react'
import ModalBase from './ModalBase'
import { useModal } from '@/hooks/useModal'
import { LoginForm, RegisterForm } from '../Forms'
import { AuthFormType, ModalType } from '@/constants/common.contant'
import ForgotPasswordForm from '../Forms/ForgotPasswordForm'

const AuthModal = () => {
  const { isModalOpen, closeModal } = useModal(ModalType.Auth)
  const [currentForm, setCurrentForm] = useState<AuthFormType>(AuthFormType.Login)

  useEffect(() => {
    if (!isModalOpen) {
      setCurrentForm(AuthFormType.Login)
    }
  }, [isModalOpen])

  const handleFormSwitch = (formType: AuthFormType) => setCurrentForm(formType)
  if (!isModalOpen) return null

  return (
    <ModalBase onClose={closeModal}>
      {currentForm === AuthFormType.Login && <LoginForm onFormSwitch={handleFormSwitch} />}
      {currentForm === AuthFormType.Register && <RegisterForm onFormSwitch={handleFormSwitch} />}
      {currentForm === AuthFormType.ForgotPassword && <ForgotPasswordForm />}
    </ModalBase>
  )
}

export default AuthModal
